module.exports = __webpack_public_path__ + "interactiveApp/KurzByk/media/3 Hovezi krk vcelku.jpg";